<template>
    <d2-container>
        <h2>资料审核</h2>
        <el-form ref="elForm"  size="medium" label-width="100px">
            <el-row>
                <el-form-item label="材料名称" prop="dd">
                    <el-input v-model="listQuery.materialName" placeholder="材料名称" clearable :style="{width: '763px'}"></el-input>
                </el-form-item>
            </el-row>
            <el-form-item size="large">
                <el-button size="small" class="filter-item" type="primary" icon="search" @click="handleFilter">查询</el-button>
                <el-button @click="resetForm">重置</el-button>
            </el-form-item>
        </el-form>


        <!--表格-->
      <el-tabs v-model="listQuery.status" @tab-click="handleFilter">
        <el-tab-pane label="待审核" :name="1"></el-tab-pane>
        <el-tab-pane label="审核通过" :name="3"></el-tab-pane>
      </el-tabs>
        <el-table :key='tableKey' :data="list" v-loading.body="listLoading" size="small" stripe highlight-current-row style="width: 100%">
          <el-table-column align="center" label="材料ID" width="65">
            <template slot-scope="scope">
              <span>{{scope.row.subId}}</span>
            </template>
          </el-table-column>
          <el-table-column width="200px" align="center" label="材料类型">
            <template slot-scope="scope">
              <span>{{materialType(scope.row.materialType)}}</span>
            </template>
          </el-table-column>
          <el-table-column width="200px" align="center" label="材料名称">
            <template slot-scope="scope">
              <span>{{scope.row.materialName}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="状态">
            <template slot-scope="scope">
              <span>{{status(scope.row.status)}}</span>
            </template>
          </el-table-column>
          <el-table-column   align="center" label="提交时间">
            <template slot-scope="scope">
              <span>{{scope.row.crtTime}}</span>
            </template>
          </el-table-column>
          <el-table-column
                    fixed="right"
                    label="操作" width="280">
                <template slot-scope="scope">
                    <el-button size="small" @click="handleClick(scope.row)" v-text="scope.row.isInput==1?'点击查看':'下载查看'"></el-button>
                    <el-button size="small" type="success" v-if="scope.row.status==3 && scope.row.authStatus!='COMPLETE'" @click="handleSign(scope.row)">盖章</el-button>
                    <el-button size="small" type="warning" v-if="scope.row.status==3 && scope.row.authStatus=='COMPLETE'" @click="handleSign(scope.row)">预览文件</el-button>
                    <el-button size="small" type="success" v-if="scope.row.status==1" @click="handleUpdate(scope.row)">审核</el-button>
                    <el-button size="small" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--分页-->
        <template slot="footer">
            <div v-show="!listLoading" class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit" layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination>
            </div>
        </template>

        <!--审核-->
        <el-dialog :fullscreen="false" :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
            <el-form :model="form" ref="form" :rules="rules" label-width="150px">
                <el-form-item label="审核类型" prop="status" required>
                  <el-radio v-model="form.status" :label="3">审核通过</el-radio>
                  <el-radio v-model="form.status" :label="2">驳回修改</el-radio>
                </el-form-item>
                <el-form-item label="驳回内容" prop="auditContent" v-if="form.status==2" required>
                  <el-input v-model="form.auditContent" placeholder="请输入"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" size="small" v-if="form.status==3" @click="form.auditContent='';update('form')">确定</el-button>
              <el-button type="primary" size="small" v-if="form.status==2" @click="update('form')">确定</el-button>
              <el-button @click="cancel('form')" size="small">取 消</el-button>
            </div>
        </el-dialog>

        <!--查看-->
        <el-dialog width="1024px" :title="'表单查看'" :visible.sync="dialogFormListVisible" v-if="dialogFormListVisible">
            <form-view @close="close()" v-if="currentRow.isInput==1" :formId="currentRow.formId" :formType="currentRow.formType" :preview="true" :key="currentRow.formType"></form-view>
        </el-dialog>

        <!--预览签署文件-->
        <el-dialog title="合同签署页面"  :visible.sync="webFrameDiglog" width="90%">
        <iframe name="webFrame" id="webFrame" style="width:100%;" height="550px"
                class="iframe" :src="webFrameUrl" frameborder="0"></iframe>

        </el-dialog>

    </d2-container>
</template>


<script>
    import {
        page,
        addObj,
        getObj,
        delObj,
        putObj,
        signContract
    } from '@/api/admin/sysEnterpriseMaterial/index';
    import FormView from "../../admin/sysForm/";
    import { mapGetters } from 'vuex';
    import {download} from "../../../api/admin/sysFiles/index";
    export default {
        name: 'sysBaseMaterial',
        components:{FormView},
        data() {
            return {
                dialogFormVisible:false,
                dialogFormListVisible:false,
                currentRow:{},
                list: null,
                total: null,
                listLoading: true,
                listQuery: {
                    page: 1,
                    limit: 20,
                    materialName:null,
                    status: 1,
                },
                dialogStatus: '',
                textMap: {
                    view: '查看',
                    update: '编辑',
                    create: '创建'
                },
                tableKey: 0,
                form:{
                    materialId:null,
                    status: null,
                    auditContent: null,
                },
                webFrameDiglog: false,
                webFrameUrl: "",
                rules: {
                  /**新增***/
                  auditContent: [
                    {
                      required: true,
                      message: '请输入驳回内容',
                      trigger: 'blur'
                    }
                  ],
                }
            }
        },
        created() {
            this.getList();
        },
        computed: {
            ...mapGetters([
                'elements'
            ])
        },
        methods: {
            materialType(materialType){
              if(materialType==0){return "附件"}
              else if(materialType==1){return "录入"}
              else{return "附件或录入"}
            },
            status(status){
              if(status==0){return "暂存"}
              else if(status==1){return "待审核"}
              else if(status==2){return "驳回不通过"}
              else if(status==3){return "审核通过"}
            },
            getList() {
                this.listLoading = true;
                page(this.listQuery).then(response => {
                    this.list = response.rows;
                    this.total = response.total;
                    this.listLoading = false;
                })
            },
            handleFilter() {
                this.getList();
            },
            handleSizeChange(val) {
                this.listQuery.limit = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.listQuery.page = val;
                this.getList();
            },
            handleCreate() {
                this.resetTemp();
                this.dialogStatus = 'create';
                this.dialogFormVisible = true;
            },
            handleClick(row) {
                if(row.isInput==1){
                    this.dialogFormListVisible=true;
                    this.currentRow=row;
                }else{
                    download(row.filePath);
                }

            },
            close(flush){
                this.dialogFormVisible=false;
                this.dialogFormListVisible=false;
                this.currentRow=null;
            },
            handleUpdate(row) {
                getObj(row.subId)
                    .then(response => {
                        this.form = response;
                        this.dialogFormVisible = true;
                        this.dialogStatus = 'update';
                    });
            },
            handleSign(row){
              signContract({subId: row.subId}).then(response=>{
                  this.webFrameDiglog = true;
                  if(response && response.status==2){
                      this.webFrameUrl = response.viewUrl;
                  }else {
                      this.webFrameUrl = response.signUrl;
                  }
              });
            },
            handleDelete(row) {
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        delObj(row.subId)
                            .then(() => {
                                this.$notify({
                                    title: '成功',
                                    message: '删除成功',
                                    type: 'success',
                                    duration: 2000
                                });
                                const index = this.list.indexOf(row);
                                this.list.splice(index, 1);
                            });
                    });
            },
            create(formName) {
                const set = this.$refs;
                set[formName].validate(valid => {
                    if (valid) {
                        addObj(this.form)
                            .then(() => {
                                this.dialogFormVisible = false;
                                this.getList();
                                this.$notify({
                                    title: '成功',
                                    message: '创建成功',
                                    type: 'success',
                                    duration: 2000
                                });
                            })
                    } else {
                        return false;
                    }
                });
            },
            cancel(formName) {
                this.dialogFormVisible = false;
                const set = this.$refs;
                set[formName].resetFields();
            },
            update(formName) {
                const set = this.$refs;
                set[formName].validate(valid => {
                    if (valid) {
                        this.dialogFormVisible = false;
                        this.form.password = undefined;
                        putObj(this.form.id, this.form).then(() => {
                            this.dialogFormVisible = false;
                            this.getList();
                            this.$notify({
                                title: '成功',
                                message: '创建成功',
                                type: 'success',
                                duration: 2000
                            });
                        });
                    } else {
                        return false;
                    }
                });
            },
            resetTemp() {
                this.form = {
                    subId:null,
                    cityName:null,
                    countyName:null,
                    streetName:null,
                    sort:null,
                };
            },
            resetForm(){
                this.listQuery={
                    page: 1,
                    limit: 20,
                    materialName: null,
                    status: null,
                }
            }
        }
    }
</script>

